import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Kanban : glisser une carte dans une colonne change le statut du ticket.
export default class extends Controller {
  static targets = ["lane"]

  start(event) {
    this.dragged = event.currentTarget
    this.dragged.classList.add("is-dragging")
    event.dataTransfer.effectAllowed = "move"
    event.dataTransfer.setData("text/plain", this.dragged.dataset.reference)
  }

  end() {
    this.dragged?.classList.remove("is-dragging")
    this.laneTargets.forEach((lane) => lane.classList.remove("is-over"))
  }

  over(event) {
    event.preventDefault()
    event.currentTarget.classList.add("is-over")
  }

  leave(event) {
    if (!event.currentTarget.contains(event.relatedTarget)) event.currentTarget.classList.remove("is-over")
  }

  async drop(event) {
    event.preventDefault()
    const lane = event.currentTarget
    lane.classList.remove("is-over")
    const card = this.dragged
    if (!card || card.closest("[data-board-target='lane']") === lane) return

    const status = lane.dataset.status
    const head = lane.querySelector(".lane__head")
    lane.querySelector(".lane__empty")?.remove()
    head.after(card)
    card.classList.add("is-saving")

    const response = await fetch(card.dataset.url, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content,
      },
      body: JSON.stringify({ ticket: { statut: status } }),
    })
    if (!response.ok) alert("Impossible de changer le statut, réessaie.")
    Turbo.visit(window.location.href, { action: "replace" })
  }

  open(event) {
    if (event.target.closest("a")) return
    Turbo.visit(event.currentTarget.dataset.url)
  }
}
